
export const SIGNUP_SUCCESS_MESSAGE =   <>
<img src="/images/icons/tick-circle.svg" />
<p style={{color: "green"}}>Please confirm your account registration via the link sent to your email.</p>
</>

export const SIGNUP_FAILED_MESSAGE =   <>
<img src="/images/icons/error.svg" />
<p style={{color: "red"}}>Failed to signup</p>
</>
